import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  updateUser(data): Observable<any> {
    const url = environment.apiUrl + `/user/updateProfile`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getUserAccount(): Observable<any> {
    const url = environment.apiUrl + `/user/getUserAccount`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getUserBetList(data): Observable<any> {
    const url = environment.apiUrl + `/bets/getUserBetList`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getUserEmailByUsername(data): Observable<any> {
    const url = environment.apiUrl + `/user/getUserEmailByUsername`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  completeActivation(data): Observable<any> {
    const url = environment.apiUrl + `/user/completeActivation`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getUserTransactions(data): Observable<any> {
    const url = environment.apiUrl + `/transactions/getUserTransactions`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getCouponDetailById(data): Observable<any> {
    const url = environment.apiUrl + `/bets/getCouponDetailById`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  getUserBetsByRaceId(data): Observable<any> {
    const url = environment.apiUrl + `/bets/getUserBetsByRaceId`;
    return this.http.post<any>(url, data, this.httpOptions);
  }

  cancelCouponById(data) {
    const url = environment.apiUrl + `/bets/cancelCoupon`;
    return this.http.post<any>(url, data, this.httpOptions);
  }
}
